import { useState, useEffect } from "react";
import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ') 
}

const TotalCantidad = ({ units = [], porUnidad, producto, updateProducto, productos, Idx, editable = false, centro=0, setProducto }) => {
    
    const [index, setIndex] = useState(0)
    const constrain = units.length

    const handleIndex = (mov) => {
        if(mov === -1 && index > 0){
            updateProducto(producto, 'Unidad', units[index - 1].Unidad,setProducto );
            return setIndex(curr => curr - 1);
        }else if(mov === 1 && index < constrain - 1){
            updateProducto(producto, 'Unidad', units[index + 1].Unidad, setProducto);
            return setIndex(curr => curr + 1);
        }
        return;
    }

    const [inputValue, setInputValue] = useState(Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(producto.Precio))// ver esto, causante

    const handleChange = (e) => {
        setInputValue(e.target.value)
    }

    const handleBlur = (e) => {
        updateProducto(producto, 'Precio', e.target.value, setProducto)
    }

    function run(valor){
        let numeros = []
        Array.from(valor).forEach((e,index) => {
        let numero = parseInt(e)
        
        try{
          if( (numero == e) || e == "." ){
              numeros.push(e)
              return e
          }
            
        }catch{
            console.log('error')
        }
    })
    return numeros.join('')
    }
    
    return(
        <>
            
            
            <td
                className={classNames(
                Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                'whitespace-nowrap px-3 py-2 text-sm text-white'
                )}
            >
                <div className="flex align-center gap-5 ">
                    <button
                        type="button"
                        onClick={() => updateProducto(producto, 'qty', producto.qty - 1, setProducto)}
                    >
                        <MinusCircleIcon
                            className="h-6 w-6 bg-secundarioMira text-secundario"
                        />
                    </button>    
                    <span className="font-semibold mt-[0.1rem]">{producto.qty}</span>
                    <button
                        type="button"
                        onClick={() => updateProducto(producto, 'qty', producto.qty + 1, setProducto)}
                    >
                        <PlusCircleIcon
                            className="h-6 w-6 bg-secundarioMira text-secundario"
                        />
                    </button>
                </div>
            </td>
        </>        
    )
}

export default TotalCantidad;